import {
  MULTIPLE_DOMAIN_SCAN_REQUEST,
  MULTIPLE_DOMAIN_SCAN_SUCCESS,
  MULTIPLE_DOMAIN_SCAN_FAILURE,
  MULTIPLE_DOMAIN_SCAN_RESET
} from '../constants/multipleDomainConstants';

export const multipleDomainScanRequest = (payload) => ({
  type: MULTIPLE_DOMAIN_SCAN_REQUEST,
  payload
});

export const multipleDomainScanSuccess = (data) => ({
  type: MULTIPLE_DOMAIN_SCAN_SUCCESS,
  payload: data
});

export const multipleDomainScanFailure = (error) => ({
  type: MULTIPLE_DOMAIN_SCAN_FAILURE,
  payload: error
});

export const multipleDomainScanReset = () => ({
  type: MULTIPLE_DOMAIN_SCAN_RESET
});